import {getTokenData} from './token.service';
import store from '../store'
import axios from 'axios';
import Vue from 'vue'
import {paramsSerializerQs, prepareParams} from '../helpers/api'
import i18nService from "./i18n.service";

const ApiService = {
  constructor () {
    this.instance = null
  },
  init () {
    this.instance = axios.create({
      baseURL: `${process.env.VUE_APP_BACKEND_ORIGIN}/api/v1`,
    });
    this.instance.interceptors.request.use(
      (config) => {
        config.headers['Accept-Language'] = config.loc || i18nService.getActiveLanguage()
        const tokenData = getTokenData()
        if (tokenData) {
          const { access_token } = JSON.parse(tokenData)
          if (access_token) config.headers.Authorization = `${access_token}`
          return config
        } else if(Vue.prototype.$msal?.data.accessToken){
          config.headers.mautorization = Vue.prototype.$msal?.data.accessToken
          return config
        } else return config
      },
      error => Promise.reject(error),
    )
    let isRefreshing = false
    let subscribers = []
    const subscribeTokenRefresh = cb => subscribers.push(cb)
    const onRefreshed = token => subscribers.map(cb => cb(token))
    this.instance.interceptors.response.use(undefined, err => {
      const config = err.config
      const status = err.response ? err.response.status : null
      const url = err.response ? err.response.config?.url : null
      const originalRequest = config
      if (status === 404 && url === 'profile'){
        store.dispatch('auth/onLogout')
      }
      if (status === 401) {
        if (!isRefreshing) {
          isRefreshing = true
          if(Vue.prototype.$msal.data.isAuthenticated) {
            Vue.prototype.$msal?.acquireToken()
              .then(() => {
                isRefreshing = false
                store.commit('auth/setAuthMsal')
                onRefreshed(Vue.prototype.$msal?.data.accessToken)
                subscribers = []
              })
              .catch(() => {
                store.dispatch('auth/onLogout')
              })
          } else {
            store.dispatch('auth/onRefreshToken')
              .then(({ data }) => {
                isRefreshing = false
                store.commit('auth/setAuth', data.payload)
                onRefreshed(data.payload.access_token)
                subscribers = []
              })
              .catch(() => {
                store.dispatch('auth/onLogout')
              })
          }
        }
        return new Promise((resolve) => {
          subscribeTokenRefresh((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`
            resolve(axios(originalRequest))
          })
        })
      }
      return Promise.reject(err)
    })
  },
  request (url, params, cfg) {
    const config = { params: prepareParams(params), paramsSerializer: paramsSerializerQs, ...cfg }
    return this.instance.get(url, config);
  },
  get (url, params, headers) {
    const { loc, ...rest } = params || {}
    const config = { params: prepareParams(rest), paramsSerializer: paramsSerializerQs }
    config.loc = loc
    if (headers) config.headers = headers
    return this.instance.get(url, config)
  },
  getFile(url, params) {
    const config = {
      params: prepareParams(params),
      responseType: 'arraybuffer',
    }
    return this.instance.get(url, config)
  },
  postFile (url, data, params = {}) {
    const config = { ...params, headers: { 'Content-Type': 'multipart/form-data' } }
    return this.instance.post(url, data, config)
  },
  post (url, data, params) {
    return this.instance.post(`${url}`, data, params);
  },
  update (url, slug, params) {
    return this.instance.put(`${url}/${slug}`, params);
  },
  put (url, params) {
    return this.instance.put(`${url}`, params);
  },
  patch (url, data, params) {
    return this.instance.patch(`${url}`, data, params);
  },
  delete (url, data) {
    return this.instance.delete(url, { ...data })
  },
}
export default ApiService
